import { type FC } from 'react'

import { useTranslation } from 'services/i18n'

import { Language } from 'types/Api'

import { getRegionalLogo } from 'utils/getRegionalLogo'

import { EnvironmentLabel } from './EnvironmentLabel'

export const Logo: FC = () => {
  const { i18n } = useTranslation()
  const { component: CountryLogo } = getRegionalLogo(i18n.language as Language)

  return (
    <div className="flex h-full items-center">
      {CountryLogo && <CountryLogo />}
      <div className="ml-2 hidden lg:block"><EnvironmentLabel /></div>
    </div>
  )
}
